import React, { memo } from 'react';
import PropTypes from 'prop-types';

import 'assets/flags-sprite/sprite.css';

import Wrapper from './styles';

const Flag = memo(({ name, className, ...props }) => {
  return (
    <Wrapper
      className={`${
        className ? `${className} ` : ''
      }icon-flag icon-_default icon-${name}`}
      {...props}
    />
  );
});

Flag.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Flag.defaultProps = {
  className: null,
};

export default Flag;
